import { useEffect } from "react";

/**
 * Redirects the user to an external URL on mount.
 * Used to retire internal form routes in favor of the Paperform.
 */
export default function ExternalRedirect({ to }) {
    useEffect(() => {
        window.location.replace(to);
    }, [to]);

    return (
        <div
            className="min-h-screen flex items-center justify-center bg-background text-ink-soft"
            data-testid="external-redirect"
        >
            <div className="text-center space-y-3">
                <p className="eyebrow">Redirecting</p>
                <p className="body text-sm">
                    Taking you to the benefits assessment form…
                </p>
                <a
                    href={to}
                    className="text-navy underline underline-offset-4 hover:text-brand text-sm"
                >
                    Continue if it doesn't happen automatically
                </a>
            </div>
        </div>
    );
}
